module.exports = __webpack_public_path__ + "media/packs/images/flags/DZ-13c464eb00e3410cdb1869b59f7abae3.png";